<template>
  <div class="overall-bg header-top p-0">
    <ApprovalConfirmation v-if="
      ApprovalListchange.length != 0 &&
      ApprovalListchange.some((item) => item['IsApproved'] == 0)
    " :approvaldata="ApprovalListchange" :approvaldetails="approvaldetails" @triggerDetails="getApprovaldata()"
      @Approve="Approve" :SuccessfullPopUp="SuccessfullPopUp" :RejectBtnHide="false" />
    <ApprovalStatus v-if="ApprovalList.length != 0" :ApprovalgetList="ApprovalList"
      :approvaldetails="approvaldetails" />
    <b-container fluid class="ps-0">
      <b-row>
        <b-col lg="4" xl="3" xxl="3" md="3" sm="2" class="staticleftsidebar" v-if="windowWidth > 545">
          <LeftBar pagename="InboundIssueDetails" masterheading="Inbound Issue" v-model="datas" :storestatus="true"
            :listed="sidebardata" :paramValues="ParamValues" :loading="loading" listtype="Issues" inorout="in">
          </LeftBar>
          <a class="back-btn" @click="goToFirstPage">
            <img alt="Vue logo" class="back" src="../../../../../../../assets/Img/icons/backtoright.svg" width="125"
              height="125" />
          </a>
        </b-col>
        <b-col lg="8" xl="9" xxl="9" md="9" sm="10">
          <b-container>
            <b-row>
              <b-col class="my-3">
                <BacktoPage :goback="$router.back" class="my-5" v-if="windowWidth <= 545"></BacktoPage>
                <div class="d-flex align-items-center justify-content-between">
                  <Headerlayout :headertext="datas.Name"></Headerlayout>
                  <Button label="Print" severity="success" icon="pi pi-print" class="printbtn ms-2" @click="Print" />
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div v-if="windowWidth > 545">
                  <section v-if="items.length !== 0" class="details_collapse">
                    <DetailsBanner :details="data" :loading="loading" class="mb-4" />
                  </section>
                  <div class="field" v-if="uploadedTableList.length != 0">
                    <label class="mb-0">{{
                      $t("PurchaseRequest.QuotationFile")
                    }}</label>
                  </div>
                  <b-row>
                    <b-col lg="3" md="4" sm="6" cols="12" class="d-flex" v-for="item in uploadedTableList">
                      <div class="fileuploadcard my-2" :title="item.fileName">
                        <div>
                          <p class="filenametxt">{{ item.fileName }}</p>
                          <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                            view
                          </div>
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2" v-if="ObjCamp.IsCamp && ObjCamp.CampDetailCard">
                    <p class="fn14 fw500">Camp Details</p>
                    <b-col lg="6" md="6" class="campdetailscard">
                      <b-row>
                        <b-col lg="8" md="8" class="d-flex align-items-center gap-2">
                          <p class="light-txt">Institute name:</p>
                          <p class="fn14 fw500">{{ ObjCamp.InstituteName }}</p>
                        </b-col>
                        <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                          <p class="light-txt">Camp date:</p>
                          <p class="fn14 fw500">
                            {{ ObjCamp.FormattedCampDate }}
                          </p>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="8" md="8" class="d-flex align-items-center gap-2 py-2">
                          <p class="light-txt">Camp type:</p>
                          <p class="fn14 fw500">{{ ObjCamp.CampType }}</p>
                        </b-col>
                        <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                          <p class="light-txt">Expected IP:</p>
                          <p class="fn14 fw500">{{ ObjCamp.ExpectedIP }}</p>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col lg="8" md="8" class="d-flex align-items-center gap-2">
                          <p class="light-txt">Camp name:</p>
                          <p class="fn14 fw500">{{ ObjCamp.CampName }}</p>
                        </b-col>
                        <b-col lg="4" md="4" class="d-flex align-items-center gap-2">
                          <p class="light-txt">Expected OP:</p>
                          <p class="fn14 fw500">{{ ObjCamp.ExpectedOP }}</p>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <TabView class="tabview-custom" ref="tabview4">
                    <TabPanel>
                      <template #header>
                        <i class="pi pi-box pe-3"></i>
                        <span>Item Received Details </span>
                      </template>
                      <SkeletonTableLoader :columns="headers" :loading="loading" />

                      <div v-if="!loading">
                        <MasterEmpty :createline="false" v-if="items.length === 0 && !loading"
                          eheader="InBound Issue Details" econtent="InBound Issue Details"
                          eimg="/src/assets/Img/icons/item-issue.svg" @createNew="" />
                        <NormalTable v-else :rowHover="true" filterDisplay="menu" responsiveLayout="scroll"
                          :columns="headers" v-model:value="items" @updatedata="Itemschanges">
                          <template v-slot:action="{ data }">
                            <span>
                              <EditIcon />
                              <DeleteIcon />
                            </span>
                          </template>
                          <template v-slot:assetassign="{ data }">
                            <span>
                              <Button v-if="data.Asset == 1" icon="pi pi-ellipsis-v"
                                class="p-button-rounded editicon p-button-text" @click="toggle($event, data)" />
                            </span>
                            <!-- <p @click="assetassign(data)" v-if="data.Asset == 1" class="blue-txt"> Asset Assign</p> -->
                          </template>
                          <template v-slot:Itemname1Slot="{ data }">
                            <p>{{ data.Itemname1 }} - {{ data.BarCodeNo }}</p>
                          </template>

                          <template v-slot:BatchNoSlot="{ data }">
                            <p v-if="data.BatchNo != ''">
                              {{ data.BatchNo }}
                            </p>
                            <p v-else>-</p>
                          </template>
                          <template v-slot:ModelNumberNameSlot="{ data }">
                            <p>
                              <span v-if="data.BrandName">{{ data.BrandName
                              }}<span v-if="data.ModelNumberName">
                                  /{{ data.ModelNumberName }}
                                  <span v-if="data.SizeName">/{{ data.SizeName }}
                                  </span>
                                </span>
                              </span>
                            </p>
                          </template>
                          <template v-slot:StockInHandSlot="{ data }">
                            {{
                              (
                                data.StockInHand -
                                (data.PickedQty + data.InTransist)
                              ).toFixed(2)
                            }}
                          </template>
                          <template v-slot:ReturnQty="{ data, rowIndex }">
                            <div class="label-d-none tablefield mb-0">
                              <TextField type="text" placeholder="" clearable :name="`ReturnStatus ${rowIndex + 1}`"
                                :id="`ReturnStatus ${rowIndex + 1}`" label="" v-model="data.HiddenReturnsQty"
                                :rules="{ required: false, numeric: true }" :requiredIcon="false" :disabled="data.ReturnStatus == 0 ? false : true
                                  " @keyup="ChkRecievedQty(data, rowIndex)" />
                            </div>
                          </template>
                          <template v-slot:Reason="{ data, rowIndex }">
                            <div class="label-d-none tablefield mb-0">
                              <CustomDropdown :items="IssueTableDropDown.Reasonoption" v-model="data.StockReasonId"
                                @change="ReasonOnChange(data)">
                              </CustomDropdown>
                              <!-- <TextArea type="text" placeholder="" clearable :name="`Reason ${rowIndex + 1}`"
                            :id="`Reason ${rowIndex + 1}`" label="" v-model="data.Reason" :rules="{ required: false }"
                            :requiredIcon="false" :disabled="data.ReturnStatus == 0 ? false : true"></TextArea> -->
                            </div>
                          </template>
                        </NormalTable>

                        <b-row v-if="items.length !== 0">
                          <!-- v-if="items[0]?.['ReturnStatus'] == 0 && ApprovalListchange[0]?.['CreatedBy'] == usersData.UserId"> -->
                          <b-col>
                            <Footer class="pb-3" @save="IsSubmit" :goback="$router.back" :isflag="5"
                              :disabled="SaveDisabled" />
                          </b-col>
                        </b-row>
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <template #header>
                        <i class="pi pi-file-edit pe-3"></i>
                        <span>Request Details </span>
                      </template>
                      <SkeletonTableLoader :columns="RequestDataHeader" :loading="Requestloading" />

                      <div v-if="!Requestloading">
                        <MasterEmpty :createline="false" v-if="RequestData.length === 0 && !Requestloading"
                          eheader="Request Details" econtent="Request Details"
                          eimg="/src/assets/Img/icons/item-issue.svg" @createNew="" />

                        <NormalTable v-else v-model:value="RequestData" :paginator="false" class="p-datatable-gridlines"
                          :rows="10" dataKey="id" :rowHover="true" filterDisplay="menu" :loading="Requestloading"
                          responsiveLayout="scroll" :columns="RequestDataHeader"
                          :globalFilterFields="globalFilterFields" :filters="filters">
                          <template v-slot:Itemname1="{ data }">
                            <span>
                              {{ data.Itemname1 }}
                            </span>
                            <span class="spantxt">
                              {{ data.BarCode }}
                            </span>
                          </template>

                          <template v-slot:Brandmodelsize="{ data }">
                            <p v-if="
                              data.BrandName == null &&
                              data.ModelNumberName == null &&
                              data.SizeName == null
                            ">
                              {{ "-" }}
                            </p>
                            <p v-else>
                              {{
                                data.BrandName != null ? data.BrandName : "-"
                              }}
                              /
                              {{
                                data.ModelNumberName != null
                                  ? data.ModelNumberName
                                  : "-"
                              }}
                              /
                              {{ data.SizeName != null ? data.SizeName : "-" }}
                            </p>
                          </template>
                        </NormalTable>
                      </div>
                    </TabPanel>
                  </TabView>
                </div>
                <div v-if="windowWidth <= 545">
                  <MobileLoader v-if="loading" v-for="item in 5" />
                  <div v-if="!loading">
                    <MasterEmpty :createline="false" v-if="items.length === 0 && !loading"
                      eheader="InBound Issue Details" econtent="InBound Issue Details"
                      eimg="/src/assets/Img/icons/item-issue.svg" @createNew="" />
                    <MobileViewCardHeader>
                      <template v-slot:mobilecard>
                        <div class="mobile-card" v-for="item in items">
                          <div class="d-flex align-items-center gap-1">
                            <p class="light-name">{{ item["RefMASNo"] }}</p>
                          </div>
                          <div class="d-flex align-items-center gap-1">
                            <p class="light-name">{{ item["ItemCode"] }} /</p>
                            <p class="light-name1">{{ item["HSNCode"] }}</p>
                          </div>
                          <p class="name">{{ item["Itemname1"] }}</p>
                          <div class="d-flex align-items-center gap-2" v-if="item['BatchNo']">
                            <p class="light-name">Batch :</p>
                            <p class="small-name">{{ item["BatchNo"] }}</p>
                          </div>
                          <div class="d-flex align-items-center gap-2">
                            <p class="light-name">Requested Quantity :</p>
                            <p class="small-name">
                              {{
                                item["RequestedQty"]
                                  ? item["RequestedQty"]
                                  : "0"
                              }}
                            </p>
                          </div>
                          <div class="d-flex align-items-center gap-2">
                            <p class="light-name">Received Quantity :</p>
                            <p class="small-name">
                              {{
                                item["RecievedQty"] ? item["RecievedQty"] : "0"
                              }}
                            </p>
                          </div>
                          <div class="d-flex align-items-center gap-2">
                            <p class="light-name">Returns :</p>
                            <p class="small-name">
                              {{
                                item["ReturnsQty"] ? item["ReturnsQty"] : "0"
                              }}
                            </p>
                          </div>
                        </div>
                      </template>
                    </MobileViewCardHeader>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </b-col>
      </b-row>
    </b-container>
  </div>
  <Menu ref="menu" id="overlay_menu" :model="itemListed" :popup="true" />

  <Toast />
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <CrystalReportPrintPopUp :ShowAndHide="CrystalReportPopup" :ParameterValues="ParameterValues"
    :PrintType="PrintType" />

  <CrystalReportPrintPopUpForTable :ShowAndHide="CrystalReportPopup1" :ParameterValues="ParameterValues1"
    :PrintType="PrintType1" @closepopup="hidepopup" />

  <DisposalRequestForm v-model:resquest_form="resquest_form" :paramvalue="ObjData" v-if="resquest_form"
    @closepopup="isClear" />
</template>

<script lang="ts">
import Headerlayout from "../../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../../components/FormComponents/BacktoMaster.vue";
import {
  defineComponent,
  ref,
  computed,
  onMounted,
  watch,
  reactive,
  onUnmounted,
} from "vue";
import LeftBar from "../../../../../../../modules/Inventory/components/MasterDetails/LeftSideBar.vue";
import Details from "../../../../../../../modules/Inventory/components/MasterDetails/Details.vue";
import MemberDetails from "../../../../../../../modules/Inventory/components/MasterDetails/MemberDetails.vue";

// import Rightsidebar from '../../../../modules/Inventory/components/Sidebar/RightSidebar/ItemDetailsSidebar.vue'
import Log from "../../../../../../../modules/Inventory/components/MasterDetails/TabsPage/Log.vue";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import POTableview from "../../../../../../../modules/Inventory/pages/Transaction/PurchaseOrder/POTable.vue";
import RequestTable from "../../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/Request/RequestTable.vue";
import PITable from "../../../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import IssueTable from "../../../../../../../modules/Inventory/pages/Transaction/StockOut/issuereturn/ItemIssueTable.vue";
import PurchaseIndentTableVue from "../../../../../../../modules/Inventory/pages/Transaction/PurchaseIndent/PurchaseIndentTable.vue";
import QuotesTableview from "../../../../../../../modules/Inventory/pages/Transaction/stockwithoutaffect/quotes/QuotesTableview.vue";
import storetab from "../../../../../../../modules/Inventory/pages/Masters/Stores/StoreMaster/StoreTab/mainstore.vue";
import ItemStoreMappingCreation from "../../../../../../../modules/Inventory/pages/Masters/Items/StoreMappingItemCategory/ItemStoreMappingTblview.vue";
import service from "../../../../../../../modules/Inventory/Service/ManufacturerService";
import commonService from "../../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import WithoutStockService from "../../../../../../../modules/Inventory/Service/WithoutStockAffectService";
import ManufacturerMasterTableview from "../../../../../../../modules/Inventory/pages/Masters/Manufacturer/ManufacturerMaster/ManufacturerMasterTableview.vue";
import ManufacturerDetailsVue from "../../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerDetails.vue";
import ManufacturerItemMappingTable from "../../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerItemMappingTable.vue";
import ManufacturerSupplierMappingTable from "../../../../../../../modules/Inventory/components/MasterDetails/TabsPage/ManufacturerSupplierMappingTable.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";
import StockInService from "../../../../../../../modules/Inventory/Service/StockInService";
import MasterEmpty from "../../../../../../../components/Masters/MasterEmpty.vue";
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import SidebarList from "../../../../../../../components/SkeletonLoaderComponents/SidebarList.vue";

import ApprovalConfirmation from "../../../../../../../components/FormComponents/ApprovalConfirmation.vue";
import ApprovalStatus from "../../../../../../../components/FormComponents/ApprovalStatus.vue";
import NormalTable from "../../../../../../../components/FormComponents/NormalTable.vue";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import TextArea from "../../../../../../../components/FormComponents/TextArea.vue";

import Service from "../../../../../../../modules/Inventory/Service/StockOutService";
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import CrystalReportPrintPopUp from "../../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import CrystalReportPrintPopUpForTable from "../../../../../../../modules/Inventory/components/Print/CrystalReportPrint.vue";
import ApprovalService from "../../../../../../../modules/Inventory/Service/PoApprovalService";
import DetailsBanner from "../../../../../../../modules/Inventory/components/Transaction/detailsbanner.vue";
import { setupHistoryManagement } from "../../../../../../../modules/Inventory/Service/HistoryManage";
// import DisposalRequestForm from "../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/view/Disposal/disposalRequestForm.vue";
import StockInFileUploadServices from "../../../../../../../modules/Inventory/Service/StockInFileUploadService";
import CustomDropdown from "../../../../../../../components/FormComponents/Dropdown.vue";
import StockReasonService from "../../../../../../../modules/Inventory/Service/StockReasonService";
import { useToast } from "primevue/usetoast";
import moment from "moment";

export default defineComponent({
  components: {
    ItemStoreMappingCreation,
    QuotesTableview,
    POTableview,
    LeftBar,
    Details,
    MemberDetails,
    TextArea,
    Log,
    Headerlayout,
    PurchaseIndentTableVue,
    RequestTable,
    PITable,
    IssueTable,
    storetab,
    ManufacturerMasterTableview,
    ManufacturerSupplierMappingTable,
    ManufacturerDetailsVue,
    ManufacturerItemMappingTable,
    Tableview,
    MasterEmpty,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    SidebarList,
    BacktoPage,
    ApprovalConfirmation,
    ApprovalStatus,
    NormalTable,
    Footer,
    TextField,
    CreateSuccessully,
    UpdatedSuccessfully,
    CrystalReportPrintPopUp,
    CrystalReportPrintPopUpForTable,
    DetailsBanner,
    // DisposalRequestForm,
    CustomDropdown,
    StockReasonService,
    WithoutStockService,
  },
  props: {
    showDetailsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },
    showItemsTab: {
      readonly: false,
      type: Boolean,
      default: false,
    },

    propsParams: {
      type: Object,
    },
  },
  setup() {
    //get local storage session data
    const { t } = useI18n();
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let entityData;
    if (SessionEntityData !== null) {
      entityData = JSON.parse(SessionEntityData);
    }
    //
    const resquest_form = ref(false);

    let items: any = ref([]);
    let RequestData: any = ref([]);
    let Requestloading = ref(false);
    let loading = ref(false);
    let SaveDisabled = ref(false);
    const ObjData = ref();
    const toggle = (event, data) => {
      ObjData.value = data;
      console.log("rows", ObjData);
      menu.value.toggle(event);
    };
    const menu = ref();
    const itemListed = ref([
      {
        items: [
          {
            label: "Asset Assign",
            visible: computed(() => ObjData.value.StatusID == 1),
            command: async () => {
              assetassign(ObjData.value);
            },
          },
          {
            label: "Asset Disposal",
            visible: computed(
              () => ObjData.value.StatusID == 1 || ObjData.value.StatusID == 2
            ),
            command: async () => {
              assetdisposal(ObjData.value);
            },
          },
        ],
      },
    ]);
    let sidebardata = ref([]);
    let Id = ref([]);
    const route = useRoute();
    const toast = useToast();

    let printvalue = ref({
      RefId: 0,
      BranchId: 0,
    });

    const paramValue = computed(() => {
      return route.query.param as string;
    });

    const successpop = ref(false);
    const updatepop = ref(false);
    const CrystalReportPopup = ref(false);

    const router = useRouter();
    const routerChangeCount = ref(0);
    let currentDate = new Date().toISOString().slice(0, 10);
    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    let ApprovalList = ref([]);
    let ApprovalListchange = ref([]);
    const Reasonoption = ref([]);
    let RequestId: any = 0;

    const IssueTableDropDown: any = ref({
      Reasonoption: [],
    });

    let approvaldetails: any = ref({
      HeaderName: "InBound Issue",
      ContentName: "InBound Issue",
      ApprovalCode: 0,
      ApprovalDate: "",
      ApprovalPrice: 0,
      CreatedAt: "",
    });
    let uploadedTableList: any = ref([]);
    function fileviewer(data) {
      debugger;
      const newTabUrl = data;
      window.open(newTabUrl, "_blank");
    }
    let SuccessfullPopUp = ref({
      accept: ref(false),
      decline: ref(false),
    });

    onMounted(() => {
      window.addEventListener("resize", handleResize);
      GetByStockInId();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    onBeforeRouteUpdate(() => {
      routerChangeCount.value++;
    });

    const goToFirstPage = () => {
      setupHistoryManagement(router, 5);
    };
    let data = ref({
      fromcount: ref(),
      tocount: ref(),
      fromstatus: "",
      fromstr: "",
      tostr: "",
      tostatus: "",
      fromstoreid: "",
      tostoreid: "",

      RequesterName: "",

      id: ref(),
      date: ref(),
    });
    //Table List
    const headers = [
      // {
      //   header: "Action",
      //   field: "RefMASNo",
      //   slot: "assetassign",
      //   class: "mediumwidth coumnfreezeleftId1",
      //   fieldDisplay: "false",
      // },
      {
        header: t("storetabdetails.inboundissuedetails.RequestId/IssueId"),
        field: "RefMASNo",
        class: "mediumwidth coumnfreezeleftId1",
      },
      {
        header: t("storetabdetails.inboundissuedetails.Code"),
        field: "ItemProductId",
        class: "smallwidth coumnfreezeleftId2",
      },
      // {
      //   header: "HSN Code",
      //   field: "HSNCode",
      // },
      {
        header: t("storetabdetails.inboundissuedetails.Name"),
        field: "Itemname1",
        slot: "Itemname1Slot",
        bodyclass: "boldclass text_overflow2",
        class: "mediumwidth coumnfreezeleftId3",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.inboundissuedetails.ExpiryDate"),
        field: "ExpiryDate",
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.inboundissuedetails.Batch"),
        field: "BatchNo",
        class: "smallwidth",
        slot: "BatchNoSlot",
        fieldDisplay: "false",
      },

      {
        header: t("storetabdetails.inboundissuedetails.UOM"),
        field: "UOMName",
        bodyclass: "right_td",
        class: "smallwidth",
      },

      // {
      //   header: t("storetabdetails.inboundissuedetails.ReqQty"),
      //   field: "RequestedQty",
      //   class: "smallwidth",
      //   bodyclass: "right_td",
      // },
      {
        header: t("storetabdetails.inboundissuedetails.ReceivedQty"),
        field: "RecievedQty",
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.inboundissuedetails.AvlQty"),
        field: "StockInHand",
        class: "smallwidth",
        bodyclass: "right_td",
        slot: "StockInHandSlot",
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.inboundissuedetails.ReturnedQty"),
        field: "ReturnsQty",
        class: "smallwidth",
        bodyclass: "right_td",
      },
      // {
      //   header: "Picked Qty",
      //   field: "PickedQty",
      //   class: "smallwidth",
      //   bodyclass: "right_td",
      // },
      // {
      //   header: "InTransist Qty",
      //   field: "InTransist",
      //   class: "smallwidth",
      //   bodyclass: "right_td",
      // },
      {
        header: t("storetabdetails.inboundissuedetails.Barcode"),
        field: "BarCode",
        class: "smallwidth",
        bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.inboundissuedetails.Brand/Model/Size"),
        field: "BatchNo",
        slot: "ModelNumberNameSlot",
        bodyclass: "text_overflow2",
        class: "mediumwidth",
        sortable: false,
        fieldDisplay: "false",
      },
      {
        header: t("storetabdetails.inboundissuedetails.PatientName"),
        field: "PatientName",
        class: "smallwidth",
        sortable: false,
      },
      {
        header: t("storetabdetails.inboundissuedetails.ReturnQty"),
        field: "",
        slot: "ReturnQty",
        fieldDisplay: "false",
        class: "smallwidth columnfreezerightId2",
        // bodyclass: "right_td",
      },
      {
        header: t("storetabdetails.inboundissuedetails.Reason"),
        field: "",
        slot: "Reason",
        fieldDisplay: "false",
        class: "mediumwidth columnfreezerightId1",
        // bodyclass: "right_td",
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      DocNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      RefNo: { value: null, matchMode: FilterMatchMode.IN, options: items },
      ToStoreName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: items,
      },
    };

    const RequestDataHeader = [
      {
        header: t("storetabdetails.outboundrequestdetails.Code"),
        field: "ItemProductId",
        class: "smallwidth newcolumnfreezeleft1",
        bodyclass: "boldclass",
      },

      {
        header: t("storetabdetails.outboundrequestdetails.Name"),
        field: "Itemname1",
        bodyclass: "boldclass text_overflow1",
        class: "mediumwidth newcolumnfreezeleft2",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.Brand/Model/Size"),
        field: "",
        slot: "Brandmodelsize",
        fieldDisplay: "false",
        bodyclass: "text_overflow1 newcolumnfreezeleft3",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.UOM"),
        field: "UOMName",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.ReqQty"),
        field: "ItemQuantity",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.ReceivedQty"),
        field: "IssueQty",
        bodyclass: "boldclass right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.ReturnQty"),
        field: "ReturnQty",
        bodyclass: "right_td",
        class: "smallwidth",
      },
      {
        header: t("storetabdetails.outboundrequestdetails.DeletedReason"),
        field: "DeletedReason",
        bodyclass: "right_td",
        class: "smallwidth",
      },
    ];

    const state = reactive({
      pagedItems: [], // contains a subset of rows for the current page
      currentPage: 1, // current page number
      pageSize: 10, // number of rows per page
      totalRows: 0, // total number of rows in the database
    });

    const createrequestForm = ref({
      IsNew: true,
      IsModified: true,
      IsDeleted: true,
      IsActive: true,
      CreatedAt: "2023-03-27T12:32:26.939Z",
      ModifiedAt: "2023-03-27T12:32:26.939Z",
      CreatedBy: 0,
      ModifiedBy: 0,
      CreatedByName: "",
      ApproverID: 0,
      TaskID: 0,
      IsApprovalRequired: true,
      ApprovalDate: "2023-03-27T12:32:26.939Z",
      TaskStatus: 0,
      TaskExpiryDate: "2023-03-27T12:32:26.939Z",
      TaskName: "",
      Taskpriority: 0,
      ResponseTimeInHours: 0,
      IsAutoApproval: true,
      Id: 0,
      DocType: "",
      RefNo: "",
      DocNo: "",
      DocDate: "2023-03-27T12:32:26.939Z",
      StoreId: 0,
      FromStore: 0,
      ToStore: 0,
      DcNo: "",
      DcDate: "2023-03-27T12:32:26.939Z",
      InvoiceNo: "",
      InvoiceDate: "2023-03-27T12:32:26.939Z",
      InWardNo: "",
      InWardDate: "2023-03-27T12:32:26.939Z",
      Type: "",
      Status: "",
      AuthorizedStatus: true,
      CancelReason: "",
      Cancelled: true,
      RefId: 0,
      Remarks: "",
      SubDetailsAmount: 0,
      TaxAmount: 0,
      DiscountAmount: 0,
      Amount: 0,
      ClosedReason: "",
      Closed: true,
      Subject: "",
      HospitalId: 0,
      BranchId: 0,
      GrnPaymentType: "",
      CrNoteAmt: 0,
      DueAmount: 0,
      PatientId: "2",
      VisitId: 3,
      TempPatientId: 1,
      EntityId: 0,
      EntityOperationId: 0,
      DeptRoleId: 0,
      IsApproved: 0,
      StoreBrMapId: 0,
      FromStoreBrMapId: 0,
      ToStoreBrMapId: 0,
      FromStoreBranchId: 0,
      ToStoreBranchId: 0,
    });

    let datas = ref({
      Id: ref(),
      Name: "",
      Code: "",
    });

    const ParamValues = ref({
      Id: 0,
      StoreId: 0,
    });

    let ObjCamp: any = ref({
      CampDetailCard: false,
      IsCamp: false,
      CampId: ref(),
      InstituteName: "",
      CampName: "",
      CampType: "",
      CampDate: "",
      FormattedCampDate: "",
      ExpectedIP: "",
      ExpectedOP: "",
    });

    ParamValues.value.Id = Number(route.query.Id);

    async function GetByStockInId() {
      debugger;
      const result = await StockInService.GetByStockInId(route.query.Id);
      ParamValues.value.StoreId = result["result"].StoreId;
      datas.value.Code = result["result"].DocNo;

      const FileUploadresult =
        await StockInFileUploadServices.getStockInFileById(route.query.Id);
      if (FileUploadresult["result"].length > 0) {
        for (let i = 0; i < FileUploadresult["result"].length; i++) {
          let Fileobj = {};
          (Fileobj["url"] =
            FileUploadresult["result"][i].FileName.split("/FileUpload/")[1]),
            (Fileobj["fileName"] =
              FileUploadresult["result"][i].FileName.split("/").pop()),
            (Fileobj["fileType"] = Fileobj["url"].split("/")[0]),
            (Fileobj["fullPath"] = FileUploadresult["result"][i].FileName),
            (Fileobj["Id"] = FileUploadresult["result"][i].Id),
            uploadedTableList.value.push(Fileobj);
        }
      } else {
        uploadedTableList.value = [];
      }
      await IsShow();
      await IsShowByStockOutId();
      await LoadRequestDetails();
      getApprovaldata();
    }

    async function IsShow() {
      debugger;
      try {
        loading.value = true;
        const pageNum = "";
        const pageSize = "";
        const columnName = "StoreId";
        const columnValue = ParamValues.value.StoreId;
        const columnName1 = "";
        const columnValue1 = "";
        let Condition =
          "sm.HospitalId=" +
          usersData.OrganizationId +
          "  and (COALESCE('" +
          usersData.BranchId +
          "', '0') = '0' OR sm.ToStoreBranchId IN (SELECT * FROM dbo.Split('" +
          usersData.BranchId +
          "', ',')))";
        const response = await StockInService.List(
          "",
          "",
          "10,11,22",
          pageNum,
          pageSize,
          columnName,
          columnValue,
          columnName1,
          columnValue1,
          "",
          "",
          1,
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          Condition
        );
        sidebardata.value = response["result"];

        console.log(sidebardata.value);

        const oldKey1 = "ToStoreName";
        const newKey1 = "Name";
        const oldKey2 = "DocNo";
        const newKey2 = "Code";
        const oldKey3 = "StockOutTransId";
        const newKey3 = "Id";
        sidebardata.value = response["result"].map((item) => {
          const newItem = {
            ...item,
            [newKey1]: item[oldKey1],
            [newKey2]: item[oldKey2],
            [newKey3]: item[oldKey3],
          };
          delete newItem[oldKey1];
          delete newItem[oldKey2];
          delete newItem[oldKey3];
          return newItem;
        });
        let obj = sidebardata.value.filter(
          (items) => items["StockTransId"] == route.query.Id
        );
        datas.value.Name = obj![0]["Name"];
        RequestId = obj[0]["RequestId"];
        //datas.value.Code = obj[0]["Code"];
        // datas.value.Id = obj[0]["Id"];
        await GetListByReason();
        await GetCampDetails();
        console.log(sidebardata.value);
        loading.value = false;
      } catch (error) {
        console.log(error);
        loading.value = false;
      }
    }

    async function GetCampDetails() {
      debugger;
      const result = await WithoutStockService.GetByStockWOTransId(RequestId);
      if (result["result"][0].IsCamp) {
        ObjCamp.value.IsCamp = result["result"][0].IsCamp;
        ObjCamp.value.CampId = result["result"][0].CampId;
        ObjCamp.value.InstituteName = result["result"][0].InstituteName;
        ObjCamp.value.CampName = result["result"][0].CampName;
        ObjCamp.value.CampType = result["result"][0].CampType;
        ObjCamp.value.CampDate = result["result"][0].CampDate;
        ObjCamp.value.FormattedCampDate = moment(
          result["result"][0].CampDate,
          "MM/DD/YYYY hh:mm:ss A"
        ).format("DD/MM/YYYY");
        ObjCamp.value.ExpectedIP = result["result"][0].ExpectedIP;
        ObjCamp.value.ExpectedOP = result["result"][0].ExpectedOP;
        ObjCamp.value.CampDetailCard = true;
      }
    }

    watch(
      () => route.query.Id,
      (newVal: any) => {
        debugger;

        ParamValues.value.Id = Number(newVal);

        GetByStockInId();
      }
    );

    async function IsShowByStockOutId() {
      debugger;
      console.log(ParamValues.value.Id);

      const result = await StockInService.getlistById(ParamValues.value.Id);
      console.log(result["result"], "Approval details for inbound issue");
      items.value = result["result"].map((item: any) => {
        item.HiddenReturnsQty = 0;
        item.Reason = "";
        item.ExpiryDate =
          item.ExpiryDate == "01-01-1900" ? "" : item.ExpiryDate;
        return item;
      });

      RequestId = result["result"][0]?.RequestId;

      printvalue.value.RefId = result["result"][0]?.RefId;

      printvalue.value.BranchId = result["result"][0]?.ToStoreBranchId;

      approvaldetails.value.ApprovalCode = result["result"][0]?.DocNo;
      approvaldetails.value.ApprovalDate = result["result"][0]?.DocDateHR;
      approvaldetails.value.CreatedAt = result["result"][0]?.CreatedAt;
      const totalIssueQty = computed(() => {
        return items.value.reduce(
          (sum, item: any) => sum + item.RecievedQty,
          0
        );
      });

      const totalItemQty = computed(() => {
        return items.value.reduce(
          (sum, item: any) => sum + item.RequestedQty,
          0
        );
      });
      data.value.fromstr = result["result"][0]?.FromStoreName;
      data.value.tostr = result["result"][0]?.ToStoreName;

      data.value.fromstoreid = result["result"][0]?.FromStoreCode;
      data.value.tostoreid = result["result"][0]?.ToStoreCode;
      data.value.fromstatus = result["result"][0]?.FromStoreType;
      data.value.tostatus = result["result"][0]?.ToStoreType;
      data.value.fromcount = totalItemQty;
      data.value.tocount = totalIssueQty;

      data.value.RequesterName = result["result"][0]?.CreatedByName;
      data.value.id = result["result"][0]?.DocNo;
      data.value.date = moment(result["result"][0]?.DocDateHR).format(
        "DD-MM-YYYY"
      );

      // data.value.id = result["result"][0].DocNo;
      // data.value.date = result["result"][0].DocDate;
    }

    async function LoadRequestDetails() {
      debugger;
      try {
        Requestloading.value = true;
        const result = await WithoutStockService.GetByStockWOTransId(RequestId);
        RequestData.value = result["result"];
        console.log(RequestData.value);
        const totalIssueQty = computed(() => {
          return RequestData.value.reduce(
            (sum, item: any) => sum + item.StockOutQty,
            0
          );
        });
        const addedItemIds = new Set();
        const totalItemQty = computed(() => {
          return RequestData.value.reduce((sum, item: any) => {
            if (!addedItemIds.has(item.ItemId)) {
              addedItemIds.add(item.ItemId);
              return sum + item.ItemQuantity;
            }
            return sum;
          }, 0);
        });

        Requestloading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    function ChkRecievedQty(data, index) {
      debugger;
      //StockInHand
      let ToBeReturn = data.RecievedQty - data.ReturnsQty;
      //if (data.StockInHand >= data.HiddenReturnsQty) {
      if (ToBeReturn < data.HiddenReturnsQty) {
        toast.add({
          severity: "warn",
          summary: "You can return " + ToBeReturn + "",
          detail:
            "Recieved " +
            data.RecievedQty +
            " - Returned " +
            data.ReturnsQty +
            " = " +
            ToBeReturn +
            "",
          life: 3000,
        });
        data.HiddenReturnsQty = 0;
      }
      // } else {
      //   toast.add({
      //     severity: "warn",
      //     summary: "Available Qty " + data.StockInHand + "",
      //     detail: "",
      //     life: 3000,
      //   });
      //   data.HiddenReturnsQty = 0;
      // }
    }
    var Barcodearr: any = [];

    async function IsSubmit() {
      debugger;
      SaveDisabled.value = true;
      let Id = 0;
      let msg;
      let arr: any = [];
      let arr1: any = [];

      // if (items.value.length > 0) {
      if (
        items.value.some((item) =>
          item["HiddenReturnsQty"] == "" ? 0 : item["HiddenReturnsQty"] > 0
        )
      ) {
        if (
          items.value.some(
            (item) => item["Reason"] != "" && item["ReturnStatus"] == 0
          )
        ) {
          createrequestForm.value.DocType = "13";
          // createrequestForm.value.Id = Number(route.query.Id);
          createrequestForm.value.RefId = Number(route.query.Id);
          createrequestForm.value.RefNo = items.value[0]["DocNo"];

          createrequestForm.value.StoreId = items.value[0]["ToStore"];
          createrequestForm.value.FromStore = items.value[0]["ToStore"];
          createrequestForm.value.ToStore = items.value[0]["FromStore"];
          createrequestForm.value.StoreBrMapId =
            items.value[0]["ToStoreBrMapId"];
          createrequestForm.value.FromStoreBrMapId =
            items.value[0]["StoreBrMapId"];
          createrequestForm.value.ToStoreBrMapId =
            items.value[0]["StoreBrMapId"];

          createrequestForm.value.FromStoreBranchId =
            items.value[0]["ToStoreBranchId"];
          createrequestForm.value.ToStoreBranchId =
            items.value[0]["FromStoreBranchId"];

          createrequestForm.value.CreatedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          createrequestForm.value.ModifiedAt = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );
          createrequestForm.value.BranchId = Number(route.query.BranchId ?? 0);
          createrequestForm.value.HospitalId = usersData.OrganizationId;
          createrequestForm.value.ModifiedBy = usersData.UserId;
          createrequestForm.value.CreatedBy = usersData.UserId;
          createrequestForm.value.EntityId = 3030;
          createrequestForm.value.EntityOperationId = 3030001;
          createrequestForm.value.DeptRoleId = rolesData.DeptRoleMapId;

          createrequestForm.value.IsApproved = 1;
          createrequestForm.value.DocDate = moment().format(
            "YYYY-MM-DDTHH:mm:ss.SSSZ"
          );

          const result = await Service.creatStockOutMasterTM(
            createrequestForm.value
          );
          msg = result["ErrorInfo"].ErrorCode;
          Id = result["result"];
          let StockOutMasterId = result["result"];
          if (msg == null) {
            for (let i = 0; i < items.value.length; i++) {
              let obj = {};
              if (
                items.value[i]["HiddenReturnsQty"] != 0 &&
                items.value[i]["HiddenReturnsQty"] != ""
              ) {
                (obj["Id"] = 0),
                  (obj["ItemId"] = items.value[i]["ItemId"]),
                  (obj["Qty"] =
                    items.value[i]["HiddenReturnsQty"] == ""
                      ? 0
                      : items.value[i]["HiddenReturnsQty"]),
                  (obj["RefId"] = Id),
                  (obj["PackSizeId"] = items.value[i]["PackageSizeId"]),
                  (obj["HSNId"] = items.value[i]["HSNId"]),
                  (obj["BarCodeNo"] = items.value[i]["BarCodeNo"]),
                  (obj["BarCode"] = items.value[i]["BarCode"]);
                if (
                  items.value[i]["ExpiryDate"] != "01-01-0001" &&
                  items.value[i]["ExpiryDate"] != ""
                ) {
                  obj["ExpiryDate"] = moment(
                    items.value[i]["ExpiryDate"],
                    "DD-MM-YYYY"
                  ).format("YYYY-MM-DD");
                } else {
                  obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
                }
                (obj["CreatedAt"] = moment().format(
                  "YYYY-MM-DDTHH:mm:ss.SSSZ"
                )),
                  (obj["ModifiedAt"] = moment().format(
                    "YYYY-MM-DDTHH:mm:ss.SSSZ"
                  )),
                  (obj["CreatedBy"] = usersData.UserId),
                  (obj["ModifiedBy"] = usersData.UserId),
                  (obj["UOM"] = items.value[i]["UOM"]),
                  (obj["Brand"] =
                    items.value[i]["Brand"] == null
                      ? 0
                      : items.value[i]["Brand"]),
                  (obj["ModelNumber"] =
                    items.value[i]["ModelNumber"] == null
                      ? 0
                      : items.value[i]["ModelNumber"]),
                  (obj["Size"] =
                    items.value[i]["Size"] == null
                      ? 0
                      : items.value[i]["Size"]),
                  (obj["IsApproved"] = 1),
                  (obj["GRNId"] = Number(route.query.Id)),
                  (obj["Remarks"] = items.value[i]["Reason"]),
                  (obj["StockReasonId"] = items.value[i]["StockReasonId"]),
                  (obj["RoomId"] = items.value[i]["RoomId"]),
                  (obj["RackId"] = items.value[i]["RackId"]),
                  (obj["RowId"] = items.value[i]["RowId"]),
                  (obj["BoxId"] = items.value[i]["BoxId"]),
                  (obj["AssetFlag"] = items.value[i]["Asset"] || 0),
                  (obj["AssetGroupId"] = items.value[i]["AssetGroupId"] || 0),
                  (obj["SerialNumber"] = items.value[i]["SerialNumber"] || ""),
                  (obj["DepreciationMethodId"] =
                    items.value[i]["DepreciationMethodId"] || 0),
                  (obj["MaintenanceScheduleID"] =
                    items.value[i]["MaintenanceScheduleID"] || 0),
                  (obj["LocationID"] = items.value[i]["LocationID"] || 0),
                  (obj["ModelNo"] = items.value[i]["ModelNo"] || ""),
                  (obj["RFIDTag"] = items.value[i]["RFIDTag"] || ""),
                  (obj["TrackingMechanism"] =
                    items.value[i]["TrackingMechanism"] || 0),
                  (obj["StatusID"] = items.value[i]["StatusID"] || 0);
                arr.push(obj);
              }
            }

            const resultDetails = await Service.createStockOutDetailsTD(arr);
            //let result1 = await Service.UpdateBarcodeStockOutQty(arr);
            msg = resultDetails["ErrorInfo"].ErrorCode;
            if (msg == null) {
              createrequestForm.value.RefId = Id;
              createrequestForm.value.RefNo = "";
              createrequestForm.value.StoreId = items.value[0]["FromStore"];
              createrequestForm.value.BranchId =
                items.value[0]["FromStoreBranchId"];
              const result1 = await StockInService.createStockInTM(
                createrequestForm.value
              );
              msg = result1["ErrorInfo"].ErrorCode;
              Id = result1["result"];
              let barcodearry: any = ref([]);
              if (msg == null) {
                for (let i = 0; i < items.value.length; i++) {
                  let obj = {};
                  barcodearry.value = [];
                  if (
                    items.value[i]["HiddenReturnsQty"] != 0 &&
                    items.value[i]["HiddenReturnsQty"] != ""
                  ) {
                    (obj["Id"] = 0),
                      (obj["ItemId"] = items.value[i]["ItemId"]),
                      (obj["Qty"] =
                        items.value[i]["HiddenReturnsQty"] == ""
                          ? 0
                          : items.value[i]["HiddenReturnsQty"]),
                      (obj["RefId"] = Id),
                      (obj["PackSizeId"] = items.value[i]["PackSizeId"]),
                      (obj["HSNId"] = items.value[i]["HSNId"]),
                      (obj["UnitMRP"] = items.value[i]["MRP"]),
                      (obj["CreatedAt"] = moment().format(
                        "YYYY-MM-DDTHH:mm:ss.SSSZ"
                      )),
                      (obj["ModifiedAt"] = moment().format(
                        "YYYY-MM-DDTHH:mm:ss.SSSZ"
                      )),
                      (obj["UOM"] = items.value[i]["UOM"]),
                      (obj["CreatedBy"] = usersData.UserId),
                      (obj["ModifiedBy"] = usersData.UserId),
                      (obj["Rate"] = items.value[i]["Rate"]);
                    obj["UnitRate"] = items.value[i]["UnitRate"];
                    obj["PurchaseTax"] =
                      items.value[i]["PurchasetaxPercentage"];
                    obj["PurchaseTaxAmount"] =
                      items.value[i]["Purchasetaxamount"];
                    obj["SalesTax"] = items.value[i]["SalestaxPercentage"] || 0;
                    obj["SalesTaxAmount"] = items.value[i]["Salestaxamount"];
                    obj["DiscountPer"] = items.value[i]["Discount"];
                    obj["DiscountAmount"] = items.value[i]["DiscountAmount"];
                    obj["ExpiryDate"] = currentDate;
                    obj["ManufactureDate"] = currentDate;
                    obj["TransportCharges"] =
                      items.value[i]["transportcharges"];
                    obj["ServiceCharges"] = items.value[i]["servicecharges"];
                    obj["OtherCharges"] = items.value[i]["othercharges"];
                    obj["BatchNo"] = items.value[i]["BatchNo"];
                    obj["TotalValue"] = items.value[i]["Totalvalue"];
                    obj["RefBarCodeNo"] = items.value[i]["BarCodeNo"];
                    obj["RefBarCode"] = items.value[i]["BarCode"];
                    if (
                      items.value[i]["ExpiryDate"] != "01-01-0001" &&
                      items.value[i]["ExpiryDate"] != "01-01-1900" &&
                      items.value[i]["ExpiryDate"]
                    ) {
                      obj["ExpiryDate"] = moment(
                        items.value[i]["ExpiryDate"],
                        "DD-MM-YYYY"
                      ).format("YYYY-MM-DD");
                    } else {
                      obj["ExpiryDate"] = "1900-01-01T19:17:58.632+05:30";
                    }
                    if (
                      items.value[i]["ManufactureDate"] != "01-01-0001" &&
                      items.value[i]["ManufactureDate"] != "01-01-1900" &&
                      items.value[i]["ManufactureDate"]
                    ) {
                      obj["ManufactureDate"] = moment(
                        items.value[i]["ManufactureDate"],
                        "DD-MM-YYYY"
                      ).format("YYYY-MM-DD");
                    } else {
                      obj["ManufactureDate"] = "1900-01-01T19:17:58.632+05:30";
                    }
                    (obj["Brand"] =
                      items.value[i]["Brand"] == null
                        ? 0
                        : items.value[i]["Brand"]),
                      (obj["ModelNumber"] =
                        items.value[i]["ModelNumber"] == null
                          ? 0
                          : items.value[i]["ModelNumber"]),
                      (obj["Size"] =
                        items.value[i]["Size"] == null
                          ? 0
                          : items.value[i]["Size"]),
                      (obj["IsApproved"] = 1);
                    (obj["AssetFlag"] = items.value[i]["Asset"] || 0),
                      (obj["AssetGroupId"] =
                        items.value[i]["AssetGroupId"] || 0),
                      (obj["SerialNumber"] =
                        items.value[i]["SerialNumber"] || ""),
                      (obj["DepreciationMethodId"] =
                        items.value[i]["DepreciationMethodId"] || 0),
                      (obj["MaintenanceScheduleID"] =
                        items.value[i]["MaintenanceScheduleID"] || 0),
                      (obj["LocationID"] = items.value[i]["LocationID"] || 0),
                      (obj["ModelNo"] = items.value[i]["ModelNo"] || ""),
                      (obj["RFIDTag"] = items.value[i]["RFIDTag"] || ""),
                      (obj["TrackingMechanism"] =
                        items.value[i]["TrackingMechanism"] || 0),
                      (obj["StatusID"] = items.value[i]["StatusID"] || 0);
                    let barcodoutearry = {};
                    barcodoutearry["BarCode"] = items.value[i]["BarCode"];
                    Barcodearr.push(barcodoutearry);
                    obj["UsedBarcode"] = Barcodearr;
                    arr1.push(obj);
                    Barcodearr = [];
                  }

                  // }
                }

                let resultDetails1 = await StockInService.createStockInDetails(
                  arr1
                );
                msg = resultDetails1["ErrorInfo"].ErrorCode;
              }
            }
          }

          if (ObjCamp.value.IsCamp) {
            const response = await Service.UpdateCampIssueClose(
              items.value[0].RefIdByMas
            );
            console.log(response["result"]);
            msg = response["ErrorInfo"].ErrorCode;
          }

          if (msg == null) {
            PrintCrystalReport(StockOutMasterId);

            let ApproveValues = ref({
              Approvalstatus: 1,
              Remarks: "",
            });
            Approve(ApproveValues.value);

            successpop.value = true;
          } else {
            alert("Somthing went wrong");
          }
        } else {
          // alert(0)
          toast.add({
            severity: "warn",
            summary: "Enter the Reason for return",
            detail: "",
            life: 3000,
          });
        }
      } else {
        toast.add({
          severity: "warn",
          summary: "Enter the Qty for return",
          detail: "",
          life: 3000,
        });
      }
      SaveDisabled.value = false;
    }

    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      IsShowByStockOutId();
    }

    const ParameterValues = ref({ Id: 0 });
    const PrintType = ref({ Type: "S", FormId: 66, ModuleId: 3 });

    function PrintCrystalReport(Id) {
      debugger;
      CrystalReportPopup.value = true;
      ParameterValues.value.Id = Id;
    }

    async function getApprovaldata() {
      debugger;
      let EntityId = 3050;
      try {
        let response = await ApprovalService.GetPOApprovalList(
          route.query.Id,
          usersData.OrganizationId,
          route.query.BranchId,
          EntityId
        );

        ApprovalList.value = response["result"];
        ApprovalListchange.value = response["result"];
        // .filter(
        //   (item) => item.DepRoleID == rolesData.DeptRoleMapId
        // );
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    }

    let isForm = ref({
      EntityOperationId: 0,
      Id: 0,
      EntityApprovalMapID: 0,
      EntityTransactionId: 0,
      ApproverID: usersData.UserId,
      DepRoleID: rolesData.DeptRoleMapId,
      IsApproved: 0,
      ApprovedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
      Remarks: "",
      EntityId: 0,
      HospitalId: usersData.OrganizationId,
    });

    async function Approve(Values) {
      debugger;
      try {
        let rowToAssign = null;
        for (let i = 0; i < ApprovalListchange.value.length; i++) {
          if (ApprovalListchange.value[i]["IsApproved"] === 0) {
            rowToAssign = ApprovalListchange.value[i];
            break; // Exit the loop once the first matching row is found
          }
        }
        if (rowToAssign) {
          isForm.value.EntityOperationId = rowToAssign["EntityOperationId"];
          isForm.value.Id = rowToAssign["ID"];
          isForm.value.EntityTransactionId = rowToAssign["EntityTransactionId"];
          isForm.value.IsApproved = Values.Approvalstatus;
          isForm.value.Remarks = Values.Remarks;
          isForm.value.EntityId = 3050;
        }
        let response;
        if (isForm.value.IsApproved == 1) {
          response = await ApprovalService.POApproval(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            if (response["result"] == 1) {
              UpdateApprovalStatus();
            }
            SuccessfullPopUp.value.accept = true;
          } else {
            alert("Somthing went wrong");
          }
        } else if (isForm.value.IsApproved == 3) {
          response = await ApprovalService.POReject(isForm.value);
          if (response["ErrorInfo"].ErrorCode == null) {
            UpdateApprovalStatus();
            SuccessfullPopUp.value.decline = true;
          } else {
            alert("Somthing went wrong");
          }
        }
        await IsShowByStockOutId();
      } catch (error) {
        console.log(error);
      }
    }

    async function UpdateApprovalStatus() {
      debugger;
      try {
        const response = await StockInService.UpdateApprovalStatus(
          route.query.Id,
          isForm.value.IsApproved
        );

        const response1 =
          await StockInService.UpdateStockInDetailApprovalStatus(
            route.query.Id,
            isForm.value.IsApproved
          );

        let message = response["ErrorInfo"].ErrorCode;

        if (message == null) {
        }
      } catch (error) {
        console.log(error);
      }
    }
    const Itemschanges = (value) => {
      debugger;
      if (value != "") {
        items.value = [];
        items.value = value;
      }
    };
    function assetassign(data) {
      router.push({
        path: "/AssignAsset",
        query: {
          Assign: "WithRequest",
          data: JSON.stringify(data),
        },
      });
    }
    function assetdisposal(data) {
      resquest_form.value = true;
    }
    function isClear() {
      resquest_form.value = false;
    }

    async function GetListByReason() {
      debugger;
      try {
        const dataresponse = await StockReasonService.getlistdata();

        IssueTableDropDown.value.Reasonoption = dataresponse["result"].map(
          (item: any) => {
            item.name = item.ReasonName;
            item.value = item.Id;
            return item;
          }
        );
      } catch (error) {
        console.log(error);
      }
    }

    function ReasonOnChange(data) {
      debugger;

      if (data.StockReasonId) {
        let ReasonData = IssueTableDropDown.value.Reasonoption.find(
          (x) => x.Id == data.StockReasonId
        );

        data.Reason = ReasonData ? ReasonData.ReasonName : "";
      }
    }

    const CrystalReportPopup1 = ref(false);

    const ParameterValues1 = ref({
      Id: 0,
      BranchId: 0,
      HospitalId: 0,
    });

    const PrintType1 = ref({
      Type: "T",
      FormId: 10,
      HeaderTitle: "InBound Issue",
      ModuleId: 3,
    });

    function Print() {
      debugger;
      CrystalReportPopup1.value = true;
      ParameterValues1.value.Id = printvalue.value.RefId;
      ParameterValues1.value.BranchId = printvalue.value.BranchId;
      ParameterValues1.value.HospitalId = usersData.OrganizationId;
    }

    const hidepopup = () => {
      CrystalReportPopup1.value = false;
    };

    return {
      Itemschanges,
      data,
      datas,
      sidebardata,
      paramValue,
      IsShow,
      Id,
      loading,
      Requestloading,
      headers,
      RequestDataHeader,
      globalFilterFields,
      filters,
      items,
      RequestData,
      ParamValues,
      goToFirstPage,
      windowWidth,
      IsSubmit,
      successpop,
      updatepop,
      closetrigger,
      PrintType,
      CrystalReportPopup,
      ParameterValues,
      ChkRecievedQty,
      ApprovalList,
      ApprovalListchange,
      approvaldetails,
      getApprovaldata,
      Approve,
      SuccessfullPopUp,
      fileviewer,
      uploadedTableList,
      usersData,
      assetassign,
      toggle,
      menu,
      itemListed,
      ObjData,
      assetdisposal,
      isClear,
      resquest_form,
      IssueTableDropDown,
      ReasonOnChange,
      ObjCamp,
      SaveDisabled,
      CrystalReportPopup1,
      ParameterValues1,
      PrintType1,
      hidepopup,
      Print,
    };
  },
});
</script>
<style lang="scss">
.p-tabview-header span {
  white-space: nowrap;
}

.tabview-custom {
  width: 99%;
}

.staticleftsidebar {
  position: sticky !important;
  top: 0;
}

.coumnfreezeleftId1 {
  position: sticky;
  left: -16px;
  z-index: 1;
  width: 40px !important;
  background-color: #e1e1e1;
}

.coumnfreezeleftId2 {
  position: sticky;
  left: 142px;
  z-index: 1;
  width: 40px !important;
  background-color: #e1e1e1;
}

.coumnfreezeleftId3 {
  position: sticky;
  left: 222px;
  z-index: 1;
  width: 140px !important;
  background-color: #e1e1e1;
}

.columnfreezerightId1 {
  position: sticky;
  right: -16px;
  z-index: 1;
  width: 40px !important;
  background-color: #e1e1e1;
}

.columnfreezerightId2 {
  position: sticky;
  right: 156px;
  z-index: 1;
  width: 40px !important;
  background-color: #e1e1e1;
}

.campdetailscard {
  border: 1px solid #e1e1e1;
  padding: 15px;
  border-radius: 5px;
  margin-top: 15px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 6px 24px 0px,
    rgba(0, 0, 0, 0.08) 0px 0px 0px 1px;
}
</style>
